import React from 'react';

import { BadgeKind, NotificationBadgeProps, DotBadgeProps, BadgeBorderColor } from '@/types';

import DotBadge from '@/components/common/badge/DotBadge';
import NotificationBadge from '@/components/common/badge/NotificationBadge';

import styles from './BadgeV2.module.scss';

export const BadgeV2 = (props: NotificationBadgeProps | DotBadgeProps): React.JSX.Element => {
  const { type, background, border = BadgeBorderColor.WHITE, size } = props;

  if (type === BadgeKind.NOTIFICATION) {
    const { layout, icon, label } = props;

    return (
      <NotificationBadge
        size={size}
        layout={layout}
        background={styles[background]}
        border={styles[border]}
        icon={icon}
        label={label}
      />
    );
  }

  if (type === BadgeKind.DOT) {
    return (
      <DotBadge background={styles[background]} border={styles[border]} size={size} />
    );
  }

  return <></>;
};

export default BadgeV2;
